import { GraphQLClient } from 'graphql-request'
import { GRAPHQL_HOST } from 'src/config/config'
import { createEnhancedLoggingWrapper } from './customWrapper'
import { getSdk } from './generated/requests'

export const apolloSdk =
  process.env.NEXT_PUBLIC_SHOW_REQUEST_LOG == 'true'
    ? getSdk(new GraphQLClient(GRAPHQL_HOST!), createEnhancedLoggingWrapper())
    : getSdk(new GraphQLClient(GRAPHQL_HOST!))
